var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSharepoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_93_158620)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6192 14.2143C16.4079 14.2143 19.4793 11.1442 19.4793 7.35714C19.4793 3.57005 16.4079 0.5 12.6192 0.5C8.83043 0.5 5.75903 3.57005 5.75903 7.35714C5.75903 11.1442 8.83043 14.2143 12.6192 14.2143Z",
    fill: "#036C70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3361 19.9286C21.8091 19.9286 24.6246 17.1144 24.6246 13.6429C24.6246 10.1714 21.8091 7.35715 18.3361 7.35715C14.8631 7.35715 12.0476 10.1714 12.0476 13.6429C12.0476 17.1144 14.8631 19.9286 18.3361 19.9286Z",
    fill: "#1A9BA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4767 24.5C16.1604 24.5 18.336 22.3254 18.336 19.6429C18.336 16.9603 16.1604 14.7857 13.4767 14.7857C10.793 14.7857 8.61743 16.9603 8.61743 19.6429C8.61743 22.3254 10.793 24.5 13.4767 24.5Z",
    fill: "#37C6D0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M13.7626 6.68857V18.8828C13.7597 19.3066 13.5029 19.6872 13.1109 19.8486C12.986 19.9013 12.8519 19.9285 12.7164 19.9286H8.62318C8.61746 19.8314 8.61746 19.74 8.61746 19.6428C8.61556 19.5475 8.61938 19.4521 8.6289 19.3571C8.73353 17.5305 9.8593 15.9189 11.5388 15.1914V14.1286C7.80106 13.5365 5.2512 10.0279 5.84351 6.29184C5.84762 6.26596 5.85186 6.2401 5.85627 6.21428C5.88472 6.02156 5.92482 5.83073 5.97632 5.64285H12.7164C13.2933 5.64505 13.7604 6.11195 13.7626 6.68857Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M12.1446 6.21428H5.85613C5.22088 9.9436 7.73044 13.4816 11.4614 14.1165C11.5744 14.1358 11.6878 14.1522 11.8016 14.1657C10.0294 15.0057 8.73797 17.3914 8.6282 19.3571C8.61869 19.4521 8.61487 19.5475 8.61677 19.6428C8.61677 19.74 8.61677 19.8314 8.62248 19.9286C8.63279 20.1206 8.65764 20.3117 8.69679 20.5H12.144C12.5679 20.4972 12.9488 20.2404 13.1102 19.8486C13.1629 19.7238 13.1902 19.5897 13.1902 19.4543V7.25999C13.188 6.6836 12.7213 6.2168 12.1446 6.21428Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M12.1448 6.21428H5.85633C5.22121 9.94395 7.73115 13.4821 11.4625 14.1169C11.5388 14.1299 11.6153 14.1416 11.692 14.152C9.977 15.0526 8.73646 17.4326 8.62898 19.3571H12.1448C12.7208 19.3528 13.1866 18.8871 13.191 18.3114V7.25999C13.1888 6.68338 12.7217 6.21647 12.1448 6.21428Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M11.5729 6.21428H5.85614C5.25642 9.73513 7.46357 13.1257 10.9269 14.004C9.61554 15.5016 8.8112 17.3752 8.62879 19.3571H11.5729C12.1498 19.3549 12.6169 18.888 12.6191 18.3114V7.25999C12.6188 6.6826 12.1506 6.2146 11.5729 6.21428Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.09012 6.21428H11.5713C12.15 6.21428 12.6192 6.68323 12.6192 7.26171V17.7383C12.6192 18.3168 12.15 18.7857 11.5713 18.7857H1.09012C0.511392 18.7857 0.0422363 18.3168 0.0422363 17.7383V7.26171C0.0422363 6.68323 0.511392 6.21428 1.09012 6.21428Z",
    fill: "url(#paint0_linear_93_158620)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.72252 12.372C4.47694 12.2092 4.27182 11.9924 4.12282 11.7383C3.97845 11.4726 3.90649 11.1737 3.91415 10.8714C3.9013 10.4622 4.03945 10.0625 4.30232 9.74855C4.57855 9.43418 4.9356 9.20139 5.33477 9.07541C5.7897 8.92573 6.2662 8.85198 6.7451 8.85712C7.37489 8.83412 8.0038 8.92214 8.60306 9.11713V10.4314C8.34268 10.2738 8.05908 10.158 7.76269 10.0886C7.44109 10.0097 7.1111 9.9702 6.77997 9.97084C6.43079 9.95803 6.08385 10.0314 5.76981 10.1846C5.52736 10.2891 5.37015 10.5275 5.36964 10.7914C5.36865 10.9515 5.43018 11.1057 5.54114 11.2211C5.6722 11.3573 5.82723 11.4681 5.99849 11.548C6.18905 11.6429 6.47489 11.769 6.85601 11.9263C6.89797 11.9395 6.93888 11.956 6.97835 11.9754C7.35345 12.122 7.71531 12.3003 8.05997 12.5086C8.32097 12.6694 8.54003 12.89 8.69911 13.152C8.8622 13.449 8.94125 13.7849 8.92778 14.1234C8.9464 14.5436 8.81781 14.957 8.56419 15.2926C8.3114 15.6011 7.97343 15.8284 7.59233 15.9463C7.14409 16.0867 6.67627 16.1546 6.20658 16.1474C5.78517 16.1493 5.36438 16.1149 4.94889 16.0446C4.59806 15.9872 4.25569 15.8866 3.92959 15.7451V14.3594C4.24131 14.582 4.58956 14.7483 4.95861 14.8509C5.32642 14.9654 5.70876 15.0266 6.09397 15.0326C6.45048 15.0551 6.80637 14.9797 7.12299 14.8143C7.34478 14.6892 7.47968 14.4522 7.474 14.1977C7.47549 14.0206 7.4054 13.8504 7.27964 13.7257C7.12324 13.5722 6.94216 13.4461 6.74398 13.3526C6.51531 13.2383 6.17858 13.0876 5.73382 12.9006C5.37999 12.7584 5.04122 12.5813 4.72252 12.372Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_93_158620",
    x1: 2.22711,
    y1: 5.39584,
    x2: 10.4289,
    y2: 19.6073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#058F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#038489"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#026D71"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_93_158620"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.5822,
    height: 24,
    fill: "white",
    transform: "translate(0.0422363 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSharepoint);
export default __webpack_public_path__ + "static/media/sharepoint.a73df37c7914815a2e115d5a531cd605.svg";
export { ForwardRef as ReactComponent };